import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

/* Components */
import PageBanner from '../components/PageBanner/banner';
import Layout from '../components/Layout/layout';
import SEO from '../components/seo';

/* Styles */
import * as styles from './styles/terms-and-conditions.module.scss';
import TermsAndConditionsContent from 'components/TermsAndConditionsContent';

const TermsAndConditions = () => {
  return (
    <Layout>
      <SEO
        title="Read out terms and conditions for our mid-lets service"
        description="Read out terms and conditions to ensure that you understand how Oasis Living can help to imporve your property letting experience. "
      />
      <PageBanner bannerText="Terms and Conditions" searchBar={false} />
      <Container>
        <Row>
          <Col className={`${styles.TermsAndConditions} mt-4`}>
            <TermsAndConditionsContent />
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default TermsAndConditions;
